import { IRecipientActivityLog, IRecipientXm } from '@nkr/models/index';
import * as moment from 'moment';

const start = moment().subtract(3, 'months').format('YYYY-MM-DD');
const end = moment().format('YYYY-MM-DD');

interface IState {
    hash: string;
    activityLogData: IRecipientActivityLog[];
    xmData: IRecipientXm[],
    activityTypeId: number,
    startDate: string,
    endDate: string,
    donorAlias: string
}

const initialState: IState = {
    hash: '',
    activityLogData: [],
    xmData: [],
    activityTypeId: 0,
    startDate: start,
    endDate: end,
    donorAlias: ''
};

const activityLogReducer = (state: IState, action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            activityLogData: action.value.activityLogData,
            xmData: action.value.xmData,
            hash: action.value.hash,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        // return { ...state, data: action.value };
    }

    if (action.type == 'activityTypeChange') {
        return { ...state, activityTypeId: action.value };
    }

    if (action.type == 'startDateChange') {
        return {
            ...state,
            startDate: action.value,
        }
    }

    if (action.type == 'endDateChange') {
        return {
            ...state,
            endDate: action.value,
        }
    }

    if (action.type == 'donorAliasChange') {
        return {
            ...state,
            donorAlias: action.value
        };
    }

    return { ...state };
};

export {
    IState, initialState,
    activityLogReducer
};